import type { VideoClipPipPosition } from "./hooks/useVideoClipSettingsStore";

export const VIDEO_CLIP_STEPS = {
  SETUP: "setup",
  COUNTDOWN: "countdown",
  RECORDING: "recording",
  PREVIEW: "preview",
} as const;

export type VideoClipStep =
  (typeof VIDEO_CLIP_STEPS)[keyof typeof VIDEO_CLIP_STEPS];

const MAX_RECORDING_DURATION_MINUTES = 30;
export const MAX_RECORDING_DURATION_MS =
  MAX_RECORDING_DURATION_MINUTES * 60 * 1000;
export const COUNTDOWN_SECONDS = 3;
export const RECORDING_TIMESLICE_MS = 1000;
export const SYSTEM_DEFAULT_DEVICE_VALUE = "__system_default__";

export const VIDEO_CONSTRAINTS = {
  width: { ideal: 1920 },
  height: { ideal: 1080 },
  frameRate: { ideal: 30 },
};

export const VIDEO_BITS_PER_SECOND = 8_000_000; // 8 Mbps for 1080p

export const PIP_SIZE_RATIO_BY_SIZE = {
  small: 0.18,
  medium: 0.22,
  large: 0.28,
};

export const PIP_POSITION_CLASS_NAMES: Record<VideoClipPipPosition, string> = {
  "bottom-left": "bottom-4 left-4",
  "bottom-right": "bottom-4 right-4",
  "top-left": "left-4 top-4",
  "top-right": "right-4 top-4",
};
